import { CheckoutSuccessfulContract } from '../checkout/checkout-successful-contract.interface';
import { ACHDiscountData } from './ach-discount-data.interface';

export interface PlanDetailsWib {
  checkoutContract?: CheckoutSuccessfulContract;
  planNumber: string;
  achDiscountData?: ACHDiscountData;
  effectiveDate: string;
  price?: number;
  paymentFrequency?: string;
}
